{
	"language": {
		"aria": "Skift sprog"
	},
	"placeholder": {
		"title": "Dit kandidatcenter er på vej",
		"body": "Der er ikke noget her endnu. Vi sender dig et link på e-mail, så snart det er klar."
	},
	"not_found": {
		"title": "Siden blev ikke fundet",
		"body": "Tjek det link, du fulgte, eller brug linket fra din e-mail."
	},
	"error_boundary": {
		"reload": "Genindlæs siden"
	},
	"login": {
		"loading": "Indlæser…",
		"title": "Log ind på dit kandidatcenter",
		"intro": "Indtast din e-mailadresse for at se dine ansøgninger.",
		"email_label": "E-mailadresse",
		"email_placeholder": "dig@eksempel.dk",
		"submit": "Log ind",
		"sending": "Sender…",
		"sent": {
			"title": "Tjek din e-mail",
			"body": "Hvis {{email}} matcher en ansøgning, er et login-link på vej.",
			"retry": "Fik du det ikke? Tjek adressen, og prøv igen"
		},
		"resent": {
			"title": "Vi har sendt dig et nyt login-link",
			"body": "Linket, du åbnede, er udløbet. Hvis din e-mail matcher en ansøgning, er et nyt login-link på vej. Det åbner den samme side.",
			"request_manually": "Fik du det ikke? Anmod om et nyt link"
		},
		"request_error": {
			"throttled": "For mange forsøg. Vent et øjeblik, og prøv igen.",
			"invalid_email": "Indtast venligst en gyldig e-mailadresse.",
			"generic": "Noget gik galt. Prøv venligst igen."
		},
		"unknown_organisation": {
			"title": "Siden blev ikke fundet",
			"body": "Tjek det link, du fulgte, eller brug linket fra din e-mail."
		},
		"error": {
			"title": "Noget gik galt",
			"body": "Vi kunne ikke indlæse denne side. Prøv venligst igen om lidt."
		}
	},
	"organisations": {
		"title": "Dine ansøgninger",
		"intro": "Vælg en virksomhed for at se de ansøgninger, du har sendt til dem.",
		"count_one": "{{count}} ansøgning",
		"count_other": "{{count}} ansøgninger",
		"empty": {
			"title": "Ingen ansøgninger endnu",
			"body": "Når du ansøger hos en virksomhed, vises den her."
		},
		"error": "Vi kunne ikke indlæse dine virksomheder. Prøv venligst igen om lidt.",
		"log_out": "Log ud",
		"logging_out": "Logger ud…"
	},
	"submissions": {
		"title": "Tidligere ansøgninger",
		"back_to_organisations": "Alle virksomheder",
		"cv_uploaded": "CV uploadet",
		"empty": {
			"title": "Ingen ansøgninger endnu",
			"body": "Ansøgninger, du sender til {{organisation}}, vises her."
		},
		"error": "Vi kunne ikke indlæse dine ansøgninger. Prøv venligst igen om lidt.",
		"log_out": "Log ud",
		"logging_out": "Logger ud…"
	},
	"profile": {
		"link": {
			"title": "Din profil",
			"cv_added": "CV tilføjet",
			"cv_missing": "Intet CV endnu"
		},
		"back": "Tilbage til ansøgningen",
		"context": "{{campaign}} · {{organisation}}",
		"contact_consent": "Du har givet tilladelse til at blive kontaktet om dette job.",
		"cv": {
			"title": "CV",
			"upload": {
				"title": "Upload dit CV",
				"drop_hint": "eller træk og slip det her",
				"constraints": "{{types}}, maks. {{size}} MB",
				"uploading": "Uploader {{fileName}}…",
				"done": "CV uploadet",
				"error_type": "Denne filtype understøttes ikke. Tilladte typer: {{types}}.",
				"error_size": "Filen er for stor. Den maksimale størrelse er {{size}} MB."
			},
			"remove": {
				"label": "Fjern {{fileName}}",
				"question": "Fjern {{fileName}}?",
				"consequence": "Arbejdsgiveren vil ikke længere kunne se den. Det kan ikke fortrydes.",
				"confirm": "Fjern CV",
				"cancel": "Annuller",
				"removing": "Fjerner…",
				"error": "Dit CV kunne ikke fjernes. Prøv igen."
			}
		},
		"work_history": {
			"title": "Erhvervserfaring",
			"description": "Fortæl os om din relevante erhvervserfaring: hvor du har arbejdet, hvad du lavede der, og hvor længe du arbejdede der. Du kan tilføje mere end ét job, hvis de er relevante.",
			"placeholder": "Beskriv et job, du har haft",
			"input_label": "Jobdetaljer",
			"save": "Gem",
			"saving": "Gemmer…",
			"cancel": "Annuller",
			"edit": "Rediger",
			"remove": "Fjern",
			"add_another": "Tilføj endnu et job",
			"error_empty": "Skriv noget, før du gemmer.",
			"error_limit": "Du kan tilføje op til {{max}} job.",
			"unsaved_changes": "Du har ugemte ændringer i din erhvervserfaring. Vil du forlade siden alligevel og miste dem?",
			"hints": {
				"label": "Detaljer i dette job",
				"included": "nævnt",
				"missing": "ikke nævnt endnu"
			}
		},
		"education": {
			"title": "Uddannelse",
			"description": "Fortæl os om din relevante uddannelse: hvad du har læst, hvor og hvornår. Uddannelser, skoler, kurser og certifikater tæller alle med. Du kan tilføje mere end én.",
			"placeholder": "Beskriv en uddannelse, skole eller et kursus",
			"input_label": "Uddannelsesdetaljer",
			"save": "Gem",
			"saving": "Gemmer…",
			"cancel": "Annuller",
			"edit": "Rediger",
			"remove": "Fjern",
			"add_another": "Tilføj endnu en uddannelse",
			"error_empty": "Skriv noget, før du gemmer.",
			"error_limit": "Du kan tilføje op til {{max}} uddannelser.",
			"unsaved_changes": "Du har ugemte ændringer i din uddannelse. Vil du forlade siden alligevel og miste dem?"
		},
		"licenses": {
			"title": "Beviser og certifikater",
			"description": "Fortæl os om beviser og certifikater, du har, f.eks. kørekort, truckcertifikat eller hygiejnebevis. Skriv hvornår du fik det, og hvornår det udløber, hvis det gør. Du kan tilføje mere end ét.",
			"placeholder": "Beskriv et bevis eller certifikat",
			"input_label": "Detaljer om beviset",
			"save": "Gem",
			"saving": "Gemmer…",
			"cancel": "Annuller",
			"edit": "Rediger",
			"remove": "Fjern",
			"add_another": "Tilføj endnu et bevis",
			"error_empty": "Skriv noget, før du gemmer.",
			"error_limit": "Du kan tilføje op til {{max}} beviser.",
			"unsaved_changes": "Du har ugemte ændringer i dine beviser. Vil du forlade siden alligevel og miste dem?"
		}
	},
	"submission": {
		"back": "Tilbage til mine ansøgninger",
		"back_short": "Tilbage",
		"not_found": {
			"title": "Ansøgningen blev ikke fundet",
			"body": "Denne ansøgning findes ikke, eller den er ikke en af dine."
		},
		"result": {
			"heading": "Bekræftelsesskærmen, du så efter din ansøgning"
		},
		"summary": {
			"title": "Oversigt over dine svar",
			"submitted_on": "Du indsendte denne formular den",
			"submitted_more_than_once": "Du udfyldte denne formular mere end én gang. Vi fletter automatisk din profil; ansøgningen nedenfor er den seneste."
		}
	}
}
